import { render, staticRenderFns } from "./batchDetail.vue?vue&type=template&id=0492cea9&scoped=true&"
import script from "./batchDetail.vue?vue&type=script&lang=js&"
export * from "./batchDetail.vue?vue&type=script&lang=js&"
import style0 from "./batchDetail.vue?vue&type=style&index=0&id=0492cea9&prod&scoped=true&lang=less&"
import style1 from "./batchDetail.vue?vue&type=style&index=1&id=0492cea9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492cea9",
  null
  
)

export default component.exports